<template>
  <div class='filter' v-click-outside='closeDropdown'>
    <modal ref='modal' class="edit-visible-filters">
      <template #body>
        <form @submit.prevent='update'>
          <div class='modal-body'>
            <h1>{{ $t('root.filters.info_visible_filters') }}</h1>
            <ul>
              <li v-for='(name, filter) in allFilters' :key='filter' :class="[{'checked-class' : formFilters.indexOf(filter) >= 0}]">
                <span>{{ name }}</span>

                <label class="checkbox-container">
                  <input type='checkbox' name='user[filters][]' :value='filter' v-model='formFilters' />
                  <span :class="['checkmark', 'fas', { 'fa-plus': formFilters.indexOf(filter) < 0, 'fa-trash-alt': formFilters.indexOf(filter) >= 0 }]"></span>
                </label>
              </li>
            </ul>
          </div>

          <div class='modal-footer'>
            <input type='submit' name='commit' :value="$t('root.filters.save_filter_config')" class='btn btn-primary'>
          </div>
        </form>
      </template>
    </modal>

    <button class="edit-default-filters own-tooltip own-tooltip-top" @click.prevent='open()' :data-tooltip="$t('root.filters.edit_default_filters')">
      <i class="fas fa-pen"></i>
    </button>

    <form class="default-filters">
      <div v-for='filter in userFilters' :key='filter' class="btn-group dropdown form-group" role="group" aria-expanded="false" ref='dropdown'>
        <button aria-expanded="false" aria-haspopup="true" data-toggle="dropdown">
          {{ $t('root.filters.' + filter) }}
          <i class="fas fa-sort-down" aria-hidden="true"></i>
        </button>

        <div class="dropdown-menu">
          <component :is="'filter-items-by-' + filter" :folder='folder' @cancel='closeDropdown' />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import _modal from '../../../_modal'
  import _filter_items_by_shared from './_filter_by_shared'
  import _filter_items_by_version from './_filter_by_version'
  import _filter_items_by_star from './_filter_by_star'
  import _filter_items_by_type from './_filter_by_type'
  import _filter_items_by_contact from './_filter_by_contact'
  import _filter_items_by_checklist from './_filter_by_checklist'
  import _filter_items_by_ocr from './_filter_by_ocr'
  import _filter_items_by_subscription from './_filter_by_subscription'
  import _filter_items_by_mime from './_filter_by_mime'
  import _filter_items_by_exp_status from './_filter_by_exp_status'
  import _filter_items_by_exp_date from './_filter_by_exp_date'
  import _filter_items_by_size from './_filter_by_size'
  import _filter_items_by_progress from './_filter_by_progress'
  import _filter_items_by_tag from './_filter_by_tag'
  import _filter_items_by_product from './_filter_by_product'
  import _filter_items_by_document from './_filter_by_document'
  import _filter_items_by_uploaded_from from './_filter_by_uploaded_from'
  import _filter_items_by_folder from './_filter_by_folder'

  export default {
    components: {
      modal: _modal,
      'filter-items-by-progress': _filter_items_by_progress,
      'filter-items-by-checklist': _filter_items_by_checklist,
      'filter-items-by-contact': _filter_items_by_contact,
      'filter-items-by-document': _filter_items_by_document,
      'filter-items-by-expdate': _filter_items_by_exp_date,
      'filter-items-by-expstatus': _filter_items_by_exp_status,
      'filter-items-by-ocr': _filter_items_by_ocr,
      'filter-items-by-filesize': _filter_items_by_size,
      'filter-items-by-mime': _filter_items_by_mime,
      'filter-items-by-folder_name': _filter_items_by_folder,
      'filter-items-by-product': _filter_items_by_product,
      'filter-items-by-shared': _filter_items_by_shared,
      'filter-items-by-klass': _filter_items_by_type,
      'filter-items-by-star': _filter_items_by_star,
      'filter-items-by-subscription': _filter_items_by_subscription,
      'filter-items-by-tag': _filter_items_by_tag,
      'filter-items-by-uploaded_from': _filter_items_by_uploaded_from,
      'filter-items-by-version': _filter_items_by_version,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    mounted() {
      $(this.$refs.dropdown).on('hide.bs.dropdown', () => {
        if (!this.isClosable)
          return false

        this.isClosable = false
        return true
      })
    },
    data() {
      return {
        formFilters: [],
        isClosable: false,
      }
    },
    computed: {
      userFilters() {
        return this.currentUser.filters || []
      },
      allFilters() {
        return {
          klass: this.$t('root.filters.show_only'),
          shared: this.$t('root.filters.shared_status'),
          contact: this.$t('root.filters.contact_connection'),
          star: this.$t('root.filters.star_status'),
          checklist: this.$t('root.filters.has_checklist'),
          version: this.$t('root.filters.version'),
          ocr: this.$t('root.filters.ocr'),
          subscription: this.$t('root.filters.subscribed'),
          mime: this.$t('root.filters.mime'),
          expstatus: this.$t('root.filters.status'),
          expdate: this.$t('root.filters.expiration_date'),
          filesize: this.$t('root.filters.size'),
          progress: this.$t('root.filters.checklist_progress'),
          tag: this.$t('root.filters.tags'),
          product: this.$t('root.filters.products'),
          document: this.$t('root.filters.documents'),
          uploaded_from: this.$t('root.filters.uploaded_from'),
          folder_name: this.$t('root.filters.folder_name')
        }
      },
    },
    methods: {
      update(e) {
        this.store.updateUser(this.currentUser, new FormData(e.target)).then(() => {
          this.store.getCurrentUser()
          this.$refs.modal.close()
        })
      },
      open() {
        this.formFilters = this.userFilters
        this.$refs.modal.open()
      },
      closeDropdown() {
        this.isClosable = true
      },
    },
  }
</script>

<style lang='sass' scoped>
  .filter
    display: flex
    margin-top: 10px
    .edit-default-filters
      border: none
      background: #5072ED
      border-radius: 50%
      width: 25px
      height: 25px
      margin-right: 10px
      i
        color: #fff
    .default-filters
      .dropdown
        > button
          background: none
          border: none
    .form-group
      margin-bottom: 0
      margin-right: 15px
    .dropdown-menu
      li
        color: #686868
        font-weight: 500
        padding-bottom: 5px
        a
          color: #686868
          font-weight: 500
      select
        border: 1px solid #ccc
        border-radius: 3px
        color: #686868
        font-weight: 500
        width: 100%
      label
        margin-bottom: 0
        padding: 5px 0 0
  .edit-visible-filters
    h1
      font-size: 16px
    ul
      list-style: none
      padding: 0
      margin: 0
      li
        display: flex
        align-items: center
        font-size: 16px
        color: #686868
        padding: 5px
        margin-bottom: 5px
        &.checked-class
          background-color: #EBF4FE
        .checkbox-container
          margin-left: auto
          .checkmark
            background: none
            &:after
              display: none
</style>
